import React from 'react';
import ReactDOM from 'react-dom';

/**
 *
 * @param params 【Component, props, childrenNode, onClose】
 * @return {{close: close}}
 * @constructor
 */
export default function CommonTipsComponent(params) {
  const Component = params.Component
  let closed = false;
  const div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    ReactDOM.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    if (Component.name === 'LoadingComponent') {
      let isLoading = document.querySelector('.loading-ctx')
      isLoading && isLoading.parentNode && isLoading.parentNode.remove()
    }
  }

  // eslint-disable-next-line no-unused-vars
  let footer = null
  if (params) {
    const originPress = params.onClose || function () {
    };
    params.onClose = (type) => {
      if (closed) {
        return;
      }

      const res = originPress(type);
      if (res && res.then) {
        res
          .then(() => {
            closed = true;
            close();
          })
          .catch(() => {
          });
      }
    };
    footer = params
  }

  ReactDOM.render(
    <Component {...params.props} children={params.childrenNode || null} close={footer}/>,
    div,
  );

  return {
    close
  };
}
